<template>
  <footer>
    <div class="Part7">
      <div class="footer w-100 row p-5 justify-content-start align-items-start">
        <div class="col-12 col-md-6 col-lg-3 d-flex flex-column justify-content-start align-items-start gap-5 mb-5">
          <router-link class="row align-items-center nav-link" :to="{ name: 'Home', params: { userId: 1 } }"
            aria-current="page">
            <img class="footer-nav-logo" src="@/assets/img/update-logo.png" alt="shwe-maw-kun-logo" />
            <!-- <div class="col">
              <img
                class="footer-logo"
                src="@/assets/img/logo.png"
                alt="shwe-maw-kun-logo"
              />
            </div>
            <div class="col">
              <router-link
                :to="{ name: 'Home', params: { userId: 1 } }"
                class="nav-link"
                aria-current="page"
              >
                <img
                  class="footer-nav-logo"
                  src="@/assets/img/navlogo.png"
                  alt="shwe-maw-kun-logo"
                />
              </router-link>
            </div> -->
          </router-link>
          <div class="copyright">
            © 2026 All Rights Reserved<br />
            Developed by K-Win Technologies Co., Ltd.
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-3 d-flex flex-column justify-content-start align-items-start gap-3 mb-5">
          <div class="d-flex flex-column justify-content-start align-items-start gap-2">
            <h6 style="font-weight: 600;">
              <span v-if="font_type == 1">Follow us</span>
              <span v-if="font_type == 2">စောင့်ကြည့်ရန်</span>
            </h6>
            <ul class="d-flex justify-content-start align-items-center gap-2" style="padding-inline-start: 0;">
              <li v-for="contact in contactUsOptions" :key="contact.key" class="list-group-item">
                <a target="_blank" :href="contact.href">
                  <span v-html="contact.icon"></span>
                </a>
              </li>
            </ul>
          </div>
          <div class="d-flex flex-column justify-content-start align-items-start gap-2">
            <h6 style="font-weight: 600;">
              <span v-if="font_type == 1">Call us</span>
              <span v-if="font_type == 2">ဆက်သွယ်ရန်ဖုန်းနံပါတ်များ</span>
            </h6>
            <ul class="call-us-list">
              <li class="list-group-item">09 252447066</li>
              <li class="list-group-item">09 428377766</li>
            </ul>
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-3 mb-5">
          <div class="d-flex flex-column justify-content-start align-items-start gap-4">
            <h5 style="font-weight: 600;">Shwe Maw Kun</h5>
            <ul class="call-us-list" style="padding-inline-start: 0;">
              <li class="list-group-item">
                <router-link :to="{ name: 'Home' }" class="nav-link cus-nav-footer" aria-current="page">
                  <span v-if="font_type == 1">Home</span>
                  <span v-if="font_type == 2">မူလစာမျက်နှာ</span>
                </router-link>
              </li>
              <li class="list-group-item">
                <router-link :to="{ name: 'AboutSchool' }" class="nav-link cus-nav-footer">
                  <span v-if="font_type == 1">About us</span>
                  <span v-if="font_type == 2">ကျောင်း</span>
                </router-link>
              </li>
              <li class="list-group-item">
                <router-link :to="{ name: 'Career' }" class="nav-link cus-nav-footer">
                  <span v-if="font_type == 1">Career</span>
                  <span v-if="font_type == 2">အလုပ်အကိုင်အခွင့်အလမ်းများ</span>
                </router-link>
              </li>
              <li class="list-group-item">
                <router-link :to="{ name: 'Contactus' }" class="nav-link cus-nav-footer">
                  <span v-if="font_type == 1">Contact us</span>
                  <span v-if="font_type == 2">ဆက်သွယ်ရန်</span>
                </router-link>
              </li>
              <li class="list-group-item">
                <router-link :to="{ name: 'NewsAndActivities' }" class="nav-link cus-nav-footer">
                  <span v-if="font_type == 1">News and Activities</span>
                  <span v-if="font_type == 2">လှုပ်ရှားမှုများ</span>
                </router-link>
              </li>
              <li class="list-group-item">
                <router-link :to="{ name: 'AppointmentEnquiry' }" class="nav-link cus-nav-footer">
                  <span v-if="font_type == 1">Appoinment</span>
                  <span v-if="font_type == 2">ကြိုတင်ချိန်းဆိုချက်</span>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-3 d-flex flex-column justify-content-start align-items-start gap-4">
          <div class="d-flex flex-column justify-content-start align-items-start gap-2">
            <h5 class="text-start" style="font-weight: 600;">
              {{ font_type == 1 ? "Address" : "ဆက်သွယ်ရန်လိပ်စာ" }}
            </h5>
            <p class="mb-1 fw-normal text-start">
              <router-link :to="{ name: 'Contactus' }" class="nav-link">
                <template v-if="font_type == 1">
                  No. 20/10,Shwe Chi Street, (Corner of Yae Htwet Oo Street),Yae
                  Aye Kwin Quarter, Taunggyi, Shan State, Myanmar
                </template>
                <template v-if="font_type == 2">
                  <span>အမှတ်(၂၀/၁၀)၊ ရွှေခြည်လမ်း နှင့် ရေထွက်ဦး လမ်းထောင့်
                    <br />
                    ရေအေးကွင်းရပ်၊ တောင်ကြီးမြို့။</span>
                </template></router-link>
            </p>
          </div>

          <div class="d-flex flex-column justify-content-start align-items-start gap-1">
            <div class="row">
              <div v-for="partner in partnerOptions" :key="partner.key" class="col-3">
                <div class="footer-partner-icon-wrapper ">
                  <img :src="partner.img" class="footer-partner-icon" :alt="partner.key" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import footerIcon1 from "@/assets/img/footer/new-footer-1.png"
import footerIcon2 from "@/assets/img/footer/new-footer-2.png"
import footerIcon3 from "@/assets/img/footer/new-footer-3.png"
import footerIcon4 from "@/assets/img/footer/new-footer-4.png"

export default {
  props: {
    font_type: [String, Number],
    path1: Boolean
  },

  components: {
    footerIcon1,
    footerIcon2,
    footerIcon3,
    footerIcon4,
  },

  setup() {
    return {
      contactUsOptions: [
        {
          key: "facebook",
          href: "https://www.facebook.com/MawKunInternationalEducationGroupMyanmar?mibextid=ZbWKwL",
          icon: `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M29.3337 15.9998C29.3337 8.63984 23.3603 2.6665 16.0003 2.6665C8.64033 2.6665 2.66699 8.63984 2.66699 15.9998C2.66699 22.4532 7.25366 27.8265 13.3337 29.0665V19.9998H10.667V15.9998H13.3337V12.6665C13.3337 10.0932 15.427 7.99984 18.0003 7.99984H21.3337V11.9998H18.667C17.9337 11.9998 17.3337 12.5998 17.3337 13.3332V15.9998H21.3337V19.9998H17.3337V29.2665C24.067 28.5998 29.3337 22.9198 29.3337 15.9998Z" fill="white"/></svg>`,
        },
        {
          key: "instagram",
          href: "https://instagram.com/smk_education_group?igshid=YmMyMTA2M2Y=",
          icon: `<svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.0027 11.8467C14.5974 11.8467 11.8508 14.594 11.8508 18C11.8508 21.406 14.5974 24.1533 18.0027 24.1533C21.4079 24.1533 24.1546 21.406 24.1546 18C24.1546 14.594 21.4079 11.8467 18.0027 11.8467ZM18.0027 22.0004C15.8021 22.0004 14.0031 20.2064 14.0031 18C14.0031 15.7936 15.7968 13.9996 18.0027 13.9996C20.2086 13.9996 22.0022 15.7936 22.0022 18C22.0022 20.2064 20.2032 22.0004 18.0027 22.0004ZM25.8412 11.595C25.8412 12.3929 25.1987 13.0302 24.4062 13.0302C23.6085 13.0302 22.9713 12.3876 22.9713 11.595C22.9713 10.8024 23.6138 10.1598 24.4062 10.1598C25.1987 10.1598 25.8412 10.8024 25.8412 11.595ZM29.9157 13.0517C29.8247 11.1291 29.3856 9.42608 27.9775 8.02298C26.5747 6.61988 24.8721 6.18074 22.9499 6.08435C20.9689 5.97188 15.0311 5.97188 13.0501 6.08435C11.1333 6.17539 9.43068 6.61453 8.02253 8.01763C6.61439 9.42073 6.1807 11.1237 6.08433 13.0463C5.97189 15.0278 5.97189 20.9669 6.08433 22.9483C6.17535 24.8709 6.61439 26.5739 8.02253 27.977C9.43068 29.3801 11.1279 29.8193 13.0501 29.9157C15.0311 30.0281 20.9689 30.0281 22.9499 29.9157C24.8721 29.8246 26.5747 29.3855 27.9775 27.977C29.3803 26.5739 29.8193 24.8709 29.9157 22.9483C30.0281 20.9669 30.0281 15.0331 29.9157 13.0517ZM27.3564 25.0744C26.9388 26.1241 26.1303 26.9327 25.0755 27.3558C23.496 27.9824 19.7481 27.8378 18.0027 27.8378C16.2572 27.8378 12.504 27.977 10.9298 27.3558C9.88042 26.9381 9.07195 26.1294 8.64897 25.0744C8.02253 23.4946 8.16709 19.7458 8.16709 18C8.16709 16.2542 8.02789 12.5001 8.64897 10.9256C9.06659 9.87593 9.87507 9.06728 10.9298 8.6442C12.5093 8.01763 16.2572 8.16222 18.0027 8.16222C19.7481 8.16222 23.5014 8.02298 25.0755 8.6442C26.1249 9.06192 26.9334 9.87058 27.3564 10.9256C27.9828 12.5054 27.8383 16.2542 27.8383 18C27.8383 19.7458 27.9828 23.4999 27.3564 25.0744Z" fill="white"/></svg>`,
        },
        {
          key: "linkedin",
          href: "https://www.linkedin.com/company/shwe-maw-kun-education-group",
          icon: `<svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M28.2857 6H7.70893C6.76607 6 6 6.77679 6 7.73036V28.2696C6 29.2232 6.76607 30 7.70893 30H28.2857C29.2286 30 30 29.2232 30 28.2696V7.73036C30 6.77679 29.2286 6 28.2857 6ZM13.2536 26.5714H9.69643V15.1179H13.2589V26.5714H13.2536ZM11.475 13.5536C10.3339 13.5536 9.4125 12.6268 9.4125 11.4911C9.4125 10.3554 10.3339 9.42857 11.475 9.42857C12.6107 9.42857 13.5375 10.3554 13.5375 11.4911C13.5375 12.6321 12.6161 13.5536 11.475 13.5536ZM26.5875 26.5714H23.0304V21C23.0304 19.6714 23.0036 17.9625 21.1821 17.9625C19.3286 17.9625 19.0446 19.4089 19.0446 20.9036V26.5714H15.4875V15.1179H18.9V16.6821H18.9482C19.425 15.7821 20.5875 14.8339 22.3179 14.8339C25.9179 14.8339 26.5875 17.2071 26.5875 20.2929V26.5714Z" fill="white"/></svg>`,
        }, {
          key: "viber",
          href: "https://invite.viber.com/?g2=AQA33LOWH3ZcM0%2BtyMUiATIehtC7nm7HaMwzBZfKJKLmbyjENzS88RQTRgOIJAKD",
          icon: `<svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.172 4.375C15.0939 4.375 9.95328 4.59375 7.21891 7.21875C5.25016 9.07812 4.48453 11.9219 4.37516 15.3125C4.15641 20.6719 5.35953 24.0625 7.32828 25.8125C7.76578 26.1406 8.85953 27.0156 10.9377 27.6719V30.4062C10.9377 30.4062 10.9377 31.5 11.5939 31.7188C11.7033 31.7188 11.8127 31.8281 11.922 31.8281C12.5783 31.8281 13.1252 31.0625 13.8908 30.2969C14.547 29.5313 15.0939 28.9844 15.422 28.4375H17.8283C19.9064 28.4375 25.047 28.2187 27.7814 25.5937C29.7502 23.625 30.5158 20.7812 30.5158 17.1719C30.6252 16.625 30.6252 15.9688 30.6252 15.3125C30.5158 11.2656 29.3127 8.53125 27.672 7C27.0158 6.45313 24.172 4.375 18.047 4.375H17.172ZM16.9533 6.45313H17.9377C23.7345 6.45313 25.922 8.3125 26.1408 8.53125C27.4533 9.625 28.2189 12.0312 28.3283 15.2031V15.6406C28.4377 16.2969 28.4377 16.8437 28.4377 17.1719C28.3283 20.4531 27.672 22.6406 26.3595 24.0625C24.0627 26.1406 19.2502 26.25 17.9377 26.25H15.8595L14.1095 28.2187L13.0158 29.4219L12.797 29.75C12.5783 29.9688 12.2502 30.4062 12.0314 30.5156V25.5937C9.84391 25.0469 8.96891 24.2813 8.75016 24.0625C7.21891 22.75 6.34391 19.5781 6.56266 15.3125V14.2188C6.78141 11.5937 7.43766 9.84375 8.53141 8.64063C10.8283 6.5625 15.6408 6.45313 16.9533 6.45313ZM16.8439 8.85938C16.297 8.85938 16.297 9.625 16.8439 9.625C20.8908 9.625 24.3908 12.3594 24.3908 17.5C24.3908 18.0469 25.1564 18.0469 25.1564 17.5C25.1564 11.9219 21.4377 8.75 16.8439 8.85938ZM12.5094 9.87109C12.2616 9.84198 12.0122 9.91021 11.8137 10.0614C10.72 10.6083 9.62516 11.7042 9.95328 12.9073C9.95328 12.9073 10.172 13.8906 11.3752 15.9688C12.0314 16.9531 12.5783 17.8281 13.1252 18.4844C13.672 19.25 14.547 20.125 15.422 20.7812C17.172 22.2031 19.9064 23.625 21.1095 23.9531C22.2033 24.2812 23.4064 23.1875 23.9533 22.0938C24.172 21.6563 24.0627 21.1094 23.6252 20.7812C22.9689 20.125 21.8752 19.3594 21.1095 18.9219C20.5627 18.5937 19.9064 18.8125 19.6877 19.1406L19.1408 19.7969C18.922 20.125 18.3752 20.125 18.3752 20.125C14.7658 19.1406 13.7814 15.4219 13.7814 15.4219C13.7814 15.4219 13.7814 14.9844 14.1095 14.6562L14.7658 14.1094C15.0939 13.8906 15.3127 13.2344 14.9845 12.6875C14.7658 12.3594 14.4377 11.7031 14.1095 11.375C13.7814 10.9375 13.1252 10.1719 13.1252 10.1719C12.9593 10.0056 12.7425 9.89966 12.5094 9.87109ZM17.6095 11.0469C17.0627 10.9375 16.9533 11.8125 17.5002 11.8125C20.5627 12.0313 22.3127 14.1094 22.2033 16.7344C22.0939 17.2813 22.9689 17.2813 22.9689 16.7344C23.0783 13.6719 21.1095 11.1563 17.6095 11.0469ZM17.9377 13.125C17.3908 13.0156 17.3908 13.8906 17.9377 13.8906C19.2502 13.8906 19.9064 14.6563 19.9064 15.9688C20.0158 16.5156 20.7814 16.5156 20.7814 15.9688C20.672 14.2188 19.6877 13.125 17.9377 13.125Z" fill="white"/></svg>`,
        },
        {
          key: "youtube",
          href: "https://www.youtube.com/@ShweMawKunPrivateSchool",
          icon: `<svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M29.5837 11.6599C29.3057 10.6129 28.4864 9.78833 27.4461 9.50849C25.5607 9 18 9 18 9C18 9 10.4395 9 8.55392 9.50849C7.51369 9.78837 6.69442 10.6129 6.41635 11.6599C5.91113 13.5577 5.91113 17.5172 5.91113 17.5172C5.91113 17.5172 5.91113 21.4767 6.41635 23.3744C6.69442 24.4214 7.51369 25.2117 8.55392 25.4915C10.4395 26 18 26 18 26C18 26 25.5606 26 27.4461 25.4915C28.4864 25.2117 29.3057 24.4214 29.5837 23.3744C30.0889 21.4767 30.0889 17.5172 30.0889 17.5172C30.0889 17.5172 30.0889 13.5577 29.5837 11.6599ZM15.5273 21.1121V13.9223L21.8465 17.5173L15.5273 21.1121Z" fill="white"/></svg>`,
        },
        {
          key: "telegram",
          href: "https://t.me/shwemawkuneducationgroup",
          icon: `<svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 6C11.3726 6 6 11.3726 6 18C6 24.6274 11.3726 30 18 30C24.6274 30 30 24.6274 30 18C30 11.3726 24.6274 6 18 6ZM23.5622 14.161C23.3816 16.0585 22.6002 20.6631 22.2026 22.7884C22.0343 23.6876 21.7031 23.9892 21.3825 24.0186C20.6857 24.0828 20.1564 23.5581 19.4815 23.1157C18.4253 22.4234 17.8287 21.9924 16.8034 21.3168C15.6187 20.5361 16.3867 20.1071 17.0619 19.4055C17.2386 19.222 20.309 16.4292 20.3685 16.1759C20.3759 16.1442 20.383 16.0259 20.3126 15.9637C20.2423 15.9016 20.1389 15.9226 20.0641 15.9395C19.9582 15.9636 18.271 17.0788 15.0025 19.2851C14.5236 19.614 14.0898 19.7742 13.7011 19.7658C13.2727 19.7565 12.4485 19.5236 11.8358 19.3244C11.0843 19.0801 10.487 18.951 10.539 18.5361C10.5661 18.32 10.8637 18.099 11.4317 17.8732C14.93 16.349 17.2627 15.3442 18.4299 14.8587C21.7624 13.4725 22.4549 13.2317 22.9062 13.2237C23.0055 13.2221 23.2275 13.2466 23.3712 13.3633C23.4668 13.4464 23.5278 13.5624 23.542 13.6883C23.5664 13.8446 23.5731 14.0031 23.5622 14.161Z" fill="white"/></svg>`,
        },
        {
          key: "tiktok",
          href: "https://www.tiktok.com/@shwe.maw.kun.priv?_r=1&_t=ZS-99OHgnGuyfM",
          icon: `<svg width="35" height="35" viewBox="-5.5 -5.5 35 35" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" fill="white"/></svg>`,
        },
      ],
      callUsOptions: [
        "09 252447066",
        "09 428377766",
      ],
      partnerOptions: [
        {
          key: "pearson-edexcel",
          img: footerIcon1,
        },
        {
          key: "cambridge",
          img: footerIcon2,
        },
        {
          key: "british-council",
          img: footerIcon3,
        },
        {
          key: "british-council",
          img: footerIcon4,
        },
      ],
    }
  },

  date() {
    return {
      links: [
        {
          url: ''
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.footer-partner-icon-wrapper {
  width: 73px;
  height: 73px;
}

.footer-partner-icon {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.nav-link {
  color: white;
  font-weight: normal;

  &:hover {
    color: rgb(200, 196, 196)
  }
}

.footer {
  color: white;
}

.footer-logo {
  width: 85px;
  height: 85px;
}

.footer-nav-logo {
  // width: 150px;
  // height: 75px;
  width: 100%;
  height: auto;
  margin-top: -12px;
}

.copyright {
  font-family: Roboto;
  font-weight: 300;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  text-align: start;
}

.call-us-list {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  padding-left: 0;
  margin-bottom: 0;
  gap: 0.5rem;
}

.cus-nav-footer {
  text-decoration: none;
}
</style>
